module.exports = __webpack_public_path__ + "static/cafe2-bce3f1f634186320d59b9cf62c97b6da.jpeg";